<template>
  <div class="app-container" >
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="轮胎维修" name="one" style="">
        <lunTai v-if="activeName=='one'" ref="lunTai"></lunTai>
      </el-tab-pane>
      <el-tab-pane label="其他维修" name="two">
        <qiTa v-if="activeName=='two'" ref="qiTa"></qiTa>
      </el-tab-pane>
      <el-tab-pane label="维修物料" name="three">
        <wuLiao v-if="activeName=='three'" ref="qiTa"></wuLiao>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import lunTai from '@/views/newTMS/costExpense/newWeiXiu/neiXiu/lunTai.vue'
import qiTa from '@/views/newTMS/costExpense/newWeiXiu/neiXiu/qiTa.vue'
import wuLiao from '@/views/newTMS/costExpense/newWeiXiu/neiXiu/wuLiao.vue'
export default {
  components: {
    lunTai, qiTa, wuLiao
  },
  data () {
    return {
      activeName: 'one'
    }
  },
  created () {
    // if (this.$route.query.ZDFlag) {
    //   this.activeName = 'two'
    // } else {
    //   this.activeName = 'one'
    // }
  },
  methods: {
    handleClick (tab) { // 新增
    }
  }
}
</script>
<style scoped lang='less'>
/deep/.el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
    background-color: #0c46a2 !important;
    color: #fff;
}
/deep/.el-tabs__header{
  margin: 0;
}
</style>
